import React, { PureComponent, Fragment } from 'react'
import { number, string, func, shape, oneOfType } from 'prop-types'
import { range } from 'lodash'

export class SvgGrid extends PureComponent {
    static propTypes = {
        viewBox: shape({
            x: number.isRequired,
            y: number.isRequired,
            width: number.isRequired,
            height: number.isRequired
        }).isRequired,
        xNumLines: number,
        yNumLines: number,
        xLabels: shape({
            num: number.isRequired,
            toStr: func.isRequired
        }),
        yLabels: shape({
            num: number.isRequired,
            toStr: func.isRequired
        }),
        zeroLabel: string,
        xLabel: oneOfType([string, number]),
        yLabel: oneOfType([string, number]),
        xLabelOffset: number,
        yLabelOffset: number,
        fontSize: number,
        clipId: string
    }

    static defaultProps = {
        xNumLines: 1,
        yNumLines: 1,
        xLabelOffset: 1,
        yLabelOffset: 1,
        fontSize: 8
    }

    componentWillMount() {
        const { viewBox: { width, height }, xNumLines, yNumLines, xLabels, yLabels } = this.props
        this.xDistanceBetweenLines = xNumLines >= 0 ? width / (xNumLines + 1) : 0
        this.yDistanceBetweenLines = yNumLines >= 0 ? height / (yNumLines + 1) : 0
        this.xDistanceBetweenLabels = xLabels && xLabels.num >= 0 ? width / (xLabels.num + 1) : 0
        this.yDistanceBetweenLabels = yLabels && yLabels.num >= 0 ? height / (yLabels.num + 1) : 0
    }
    renderXLine = i => {
        const { viewBox: { x, y, height } } = this.props
        const lineX = x + (i * this.xDistanceBetweenLines)
        return (
            <path key={i} d={`M${lineX},${y} L${lineX},${y + height}`} />
        )
    }
    renderYLine = i => {
        const { viewBox: { x, y, width } } = this.props
        const lineY = y + (i * this.yDistanceBetweenLines)
        return (
            <path key={i} d={`M${x},${lineY} L${x + width},${lineY}`} />
        )
    }
    renderXLabel = i => {
        const { viewBox: { x, y, width }, xLabels, fontSize } = this.props
        const lineX = i * this.xDistanceBetweenLabels
        return <tspan key={i} x={x + lineX} y={y - fontSize} textAnchor="middle">{xLabels.toStr(lineX / width)}</tspan>
    }
    renderYLabel = i => {
        const { viewBox: { x, y, width, height }, yLabels, fontSize } = this.props
        const lineY = i * this.yDistanceBetweenLabels
        return <tspan key={i} x={x + width + fontSize} y={y + lineY}>{yLabels.toStr(lineY / height)}</tspan>
    }
    render() {
        const { viewBox: { x, y, width, height }, xNumLines, yNumLines, xLabels, yLabels, xLabel, yLabel, xLabelOffset, yLabelOffset, zeroLabel, clipId, fontSize, className } = this.props
        return (
            <Fragment>
                {clipId && (
                    <defs>
                        <clipPath id={clipId}>
                            <rect x={x - 1} y={y - 1} width={width + 2} height={height + 2} />
                        </clipPath>
                    </defs>
                )}
                <g className={['SvgGrid', className]} stroke="none" strokeWidth="1" fill="none">
                    <text className="labels" fontSize={fontSize}>
                        {zeroLabel && (
                            <tspan
                                id="label-0"
                                x={x - (0.5 * fontSize)}
                                y={y + height + (1.5 + fontSize)}
                                textAnchor="end"
                            >
                                {zeroLabel}
                            </tspan>
                        )}
                        {yLabel && (
                            <tspan
                                id="label-y-100"
                                x={x - fontSize}
                                y={y + Math.max((1 - yLabelOffset) * height, fontSize)}
                                textAnchor="end"
                            >
                                {yLabel}
                            </tspan>
                        )}
                        {xLabel && (
                            <tspan
                                id="label-x-100"
                                x={x + (xLabelOffset * width)}
                                y={y + height + (1.5 * fontSize)}
                                textAnchor={xLabelOffset > 0.9 ? 'end' : 'middle'}
                            >
                                {xLabel}
                            </tspan>
                        )}
                        {xLabels && range(0, xLabels.num + 2).map(this.renderXLabel)}
                        {yLabels && range(0, yLabels.num + 2).map(this.renderYLabel)}
                    </text>
                    <g className="grid">
                        <rect id="rectangle" x={x} y={y} width={width} height={height} />
                        {range(1, xNumLines + 1).map(this.renderXLine)}
                        {range(1, yNumLines + 1).map(this.renderYLine)}
                    </g>
                </g>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Svg/SvgGrid.js